<script setup>
	import { computed, defineProps } from 'vue'
    import { advertiserMapping } from '../constants/selectOptions.js'

	const props = defineProps({
		advertiser: {
			type: String
		}
	})

    const textString = computed(() => {
        if (advertiserMapping[props.advertiser]) {
            if (advertiserMapping[props.advertiser].did !== null) {
                return `
                    <p>Based on the information you provided, you could qualify for debt relief.</p>
                    <p><strong>For priority support and to see how much you could save, call <a href="tel:${advertiserMapping[props.advertiser].did.replace(/-/g, '')}" class="text-link">${advertiserMapping[props.advertiser].did}</a> and a ${advertiserMapping[props.advertiser].buyer} support agent will be able to help you immediately.</strong></p>
                    <p>It's 100% free, confidential, and requires absolutely no commitment.</p>
                    <a href="tel:${advertiserMapping[props.advertiser].did.replace(/-/g, '')}" class="cta-phone">Call Now For Priority Support</a>
                `
            } else {
                return `
                    <p>Based on the information you provided, you could qualify for debt relief.</p>
                    <p>A debt relief specialist from <strong>${advertiserMapping[props.advertiser].buyer}</strong> will contact your shortly. Be sure to answer your phone.</p>
                    <p>It's 100% free, confidential, and requires absolutely no commitment.</p>
                `
            }
        } else {
            return '<p>A debt relief specialist will contact you shortly.</p>'
        }
	})

    const headlineString = computed(() => {
        if (advertiserMapping[props.advertiser].buyer === 'National Debt Relief') {
            return 'You qualify for a free consultation!'
        } else {
            return 'Thanks for submitting your application!'
        }
    })

    const buyerName = computed(() => {
        return advertiserMapping[props.advertiser] ? advertiserMapping[props.advertiser].buyer : ''
    })
</script>

<template>
	<section class="container">
		<div class="row justify-content-center text-center">
			<div class="col-12 col-xl-8 mt-4">
                <h1>{{ headlineString }}</h1>
                <div v-html="textString"></div>

                <hr class="customline">

                <h3>What Happens Next?</h3>

                <p class="listPoint">You'll soon receive a call from a certified {{ buyerName }} debt relief specialist.</p>
                <p class="listPoint">Your debt specialist will be able to review your information, make any necessary changes, and customize your plan to helping you become debt free.</p>
                <p class="listPoint">The process is free, confidential, and requires absolutely no commitment.</p>
			</div>
		</div>
	</section>
</template>

<style scoped>
    .container {
        min-height: 600px;
        min-height: 65vh;
    }
    .review-box {
        text-align: left;
        background-color: #fafafa;
        padding: 20px;
        margin-bottom: 15px;
    }

    .review-name {
        font-weight: 600;
        margin-bottom: 0;
    }

    .review-img img {
        max-width: 100px;
    }

    .review-date {
        text-align: right;
        float: right;
    }

    .review-text {
        font-weight: 300;
        font-size: .93em;
    }
    a.phone-cta,
    p.phone-cta {
        color: #ff8800;
        font-size: 2em;
        font-weight: 500;
        display: block;
        cursor: pointer;
    }
    .bbb-review-img {
        max-width: 150px;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .customline {
        margin-top: 40px;
    }

    h1 {
        margin-top: 10px;
    }

    h3 {
        margin-top: 70px;
        margin-bottom: 50px;
        font-weight: 700;
    }

    .listPoint {
        text-align: left;
        padding-left: 60px;
        margin-bottom: 30px;
        position: relative;
    }

    .listPoint::before {
        display: inline-block;
        position: absolute;
        left: 0;
        top: -6px;
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;
        font: var(--fa-font-regular);
        content: '\f058';
        font-size: 40px;
        margin-right: 20px;
    }
	
</style>
<style>
    a.cta-phone {
        background-color: #0D496F;
        border-color: #0D496F;
        padding: 20px 0;
        font-size: 1.4em;
        font-weight: 700;
        border-radius: 39px;
        transition: all .3s ease;
        box-shadow: 0 10px 15px #00ACEF4d;
        display: block;
        width: 100%;
        margin-top: 20px;
        margin-bottom: 20px;
        color: #fff;
    }

    a.text-link {
        color: #0D496F;
        text-decoration: underline;
    }
</style>